<div
  [ngClass]="
    switchBtnHidden
      ? 'p-form-origin-to-destination'
      : 'p-form-origin-to-destination p-form-origin-to-destination--has-inverse'
  "
>
  <div
    class="p-form-origin-to-destination__item p-form-origin-to-destination__item--origin"
    [ngClass]="{ 'is-active': isError(status.origin) }"
  >
    <ng-content select="[origin]"></ng-content>
  </div>
  <ng-container *ngIf="!switchBtnHidden">
    <div class="p-form-origin-to-destination__inverse">
      <button id="{{ id }}" class="p-form-origin-to-destination__inverse-btn" (click)="switch()">
        <span class="u-visually-hidden">{{ staticMessage.swapAirportCity | staticMsg }}</span>
      </button>
    </div>
  </ng-container>
  <div
    class="p-form-origin-to-destination__item p-form-origin-to-destination__item--destination"
    [ngClass]="{ 'is-active': isError(status.destination) }"
  >
    <ng-content select="[destination]"></ng-content>
  </div>
</div>
<ng-container *ngIf="isError(status.origin) && originErrorMsg">
  <asw-validation-error [errorMessage]="originErrorMsg"></asw-validation-error>
</ng-container>
<ng-container *ngIf="isError(status.destination) && destinationErrorMsg">
  <asw-validation-error [errorMessage]="destinationErrorMsg"></asw-validation-error>
</ng-container>
